import React from 'react';
import {useHistory} from 'react-router-dom';
import {Normalize} from 'styled-normalize';
import {
    Main,
    Wrapper,
    //WrapperLoja
} from './styled';
import { LogoRumina } from "../../components/Base/styled";
import LogoRuminaSvg from '../../assets/images/rumina-logo-horizontal.png';

export * from './ColumnLeft';
export * from './ColumnRight';
export * from './ContentContainer';

const Base = ({ children, width, isAppWeb, isStore, isImilk, backgroundForm}) => {
    console.log("🚀 ~ file: index.js:13 ~ Base ~ isAppWeb, isStore, isImilk:", backgroundForm)
    
    const history = useHistory();
    const marginRoutes = ['/login', '/esqueci-minha-senha'];

    return (
        <>
            <Normalize />
            <Main isAppWeb={isAppWeb} isStore={isStore} isImilk={isImilk}>

                <Wrapper
                    backgroundForm={backgroundForm}
                    width={width}
                    isAppWeb={isAppWeb}
                    isStore={isStore}
                    isImilk={isImilk}
                    marginTop={marginRoutes.includes(history.location.pathname) ? 450 : 0}>
                    {children}
                </Wrapper>

                {
                    isImilk && (
                        <div style={{ textAlign: 'center', bottom: 0, position: 'absolute', width: '100%' }}>
                            <LogoRumina src={LogoRuminaSvg} alt="Logo do site" title="OnFarm" />
                        </div>
                    )
                }

            </Main>
        </>
    );
};

export default Base;
